module.exports = __webpack_public_path__ + "img/twitter.61e8ff5c.png";